import "swiper/css";
import CustomersPartnersSlide from "./CustomersPartnersSlide";

import sp from "../../../assets/images/Footer/sp.svg";

export default function CustomersPartners() {
  return (
    <div className="w-full">
      <div className="w-full container mx-auto px-[20px] py-[20px] flex flex-col gap-6">
        <div className="w-full flex flex-row items-center justify-center gap-1 md:gap-2 ">
          <div>
            <img src={sp} alt="cu" className="hidden md:block" />
          </div>
          <p className="text-[21px] md:text-[32px] text-[#053CC8] font-semibold text-center">
            KHÁCH HÀNG CỦA CHÚNG TÔI
          </p>
        </div>

        <div>
          <CustomersPartnersSlide />
        </div>
      </div>
    </div>
  );
}
